import { Col, Form, Input, Row } from "antd"

import Flex from "#blocks/Flex"
import { AddStudentFormValues } from "#customTypes/composedTypes/studentTypes"

import AddStudentInfo from "./AddStudentInfo"
import StudentProfileTabs from "./StudentProfileTabs"
import ViewPortfolioButton from "./ViewPortfolioButton"

const StudentProfile = ({
  initialValues,
}: {
  initialValues: AddStudentFormValues
}) => {
  return (
    <Row gutter={40}>
      <Col span={6}>
        <AddStudentInfo initialValues={initialValues} />
      </Col>
      <Col span={18}>
        <Flex col gap={8}>
          <ViewPortfolioButton />
          <StudentProfileTabs />
        </Flex>
      </Col>

      <Form.Item name="id" style={{ display: "none" }}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="avatar" style={{ display: "none" }}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="name" style={{ display: "none" }}>
        <Input type="hidden" />
      </Form.Item>
    </Row>
  )
}

export default StudentProfile
